/* eslint-disable max-len, no-use-before-define */
var generic = generic || {};

(function ($) {
  Drupal.behaviors.dynamicPickPromoV2 = {
    attached: false,
    selectors: {
      template: '.js-guided-pick-promo-v2',
      product: '.js-guided-pick-product-item',
      productButton: '.js-guided-pick-product-button',
      productImage: '.js-guided-pick-product-image',
      thresholdContainer: '.js-guided-pick-threshold-container',
      thresholdPopupContainer: '.js-guided-threshold-popup-container',
      thresholdPopupPartialText: '.js-guided-pick-threshold-popup-partial-text',
      thresholdAtbPopupContainer: '.js-guided-threshold-atb-popup-container',
      stickyContainer: '.js-guided-pick-sticky-container',
      stickyText: '.js-guided-pick-sticky-text',
      stickyItemContainer: '.js-guided-pick-sticky-item-container',
      stickyItem: '.js-guided-pick-sticky-item',
      stickyItemImageContainer: '.js-guided-pick-sticky-item-image-container',
      stickyItemButton: '.js-guided-pick-sticky-item-button',
      stickyButton: '.js-guided-pick-sticky-button'
    },

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;

      $(self.selectors.template, context).each(function () {
        self.setup($(this));
      });
    },

    setup: function ($template) {
      var self = this;

      self.getDom($template);
      self.setEvents($template);
      self.init($template);
    },

    getDom: function ($template) {
      var self = this;

      $template.nodes = {};
      $template.nodes.$product = $(self.selectors.product, $template);
      $template.nodes.$productButton = $(self.selectors.productButton, $template);
      $template.nodes.$thresholdContainer = $(self.selectors.thresholdContainer, $template);
      $template.nodes.$thresholdPopupContainer = $(self.selectors.thresholdPopupContainer, $template);
      $template.nodes.$thresholdPopupPartialText = $(self.selectors.thresholdPopupPartialText, $template);
      $template.nodes.$stickyContainer = $(self.selectors.stickyContainer, $template);
      $template.nodes.$stickyText = $(self.selectors.stickyText, $template);
      $template.nodes.$stickyItemContainer = $(self.selectors.stickyItemContainer, $template);
      $template.nodes.$stickyItem = $(self.selectors.stickyItem, $template);
      $template.nodes.$stickyButton = $(self.selectors.stickyButton, $template);

      $template.buttonSelectText = $template.attr('data-select');
      $template.buttonSelectedText = $template.attr('data-selected');
      $template.buttonSoldOutText = $template.attr('data-sold-out');
      $template.buttonAddToBagText = site.translations.product.add_to_bag;
      $template.stickyPartialPluralText = $template.nodes.$stickyText.attr('data-selected-partial-plural-text');
      $template.stickyPartialSingularText = $template.nodes.$stickyText.attr('data-selected-partial-singular-text');
      $template.stickyCompleteText = $template.nodes.$stickyText.attr('data-selected-complete-text');
      $template.thresholdPopupPartialPluralText = $template.nodes.$thresholdPopupPartialText.attr('data-selected-partial-plural-text');
      $template.thresholdPopupPartialSingularText = $template.nodes.$thresholdPopupPartialText.attr('data-selected-partial-singular-text');

      $template.loading = false;
      $template.cart = {
        subtotal: 0,
        items: [],
        samples: []
      };
      $template.selectedSkus = [];
      $template.threshold = {
        value: 0,
        amount: 0,
        offerCode: '',
        $atbPopup: $()
      };
    },

    setEvents: function ($template) {
      var self = this;

      $template.nodes.$productButton.once().on('click', function () {
        var $button = $(this);
        var $product = $button.closest(self.selectors.product);
        var skuBaseId = $product.attr('data-sku-base-id');
        var maxThreshold = parseInt($template.nodes.$thresholdContainer.last().attr('data-threshold-value'));

        if ($button.hasClass('disabled')) {
          return $template.threshold.value < maxThreshold && generic.overlay.launch({
            content: $template.nodes.$thresholdPopupContainer.clone().removeClass('hidden'),
            cssClass: 'guided-pick-popup-overlay dynamic-pick-popup-overlay',
            hideOnClickOutside: true,
            backgroundNodeClickHide: true
          });
        }

        self.toggleProduct($template, $product);
        self.checkThreshold($template);

        if ($template.threshold.value === 1) {
          $template.selectedSkus.includes(skuBaseId) ? self.applyOffer($template) : self.removeOffer($template);
        }
      });

      $template.nodes.$stickyButton.once().on('click', function () {
        if ($template.selectedSkus.length > 0) {
          self.applyOffer($template);
        }
      });

      $(document).on('cart.updated', function (e, data) {
        var cartData = data?.trans_data;

        if (cartData) {
          $template.cart.subtotal = cartData.subtotal && parseFloat(cartData.subtotal);
          $template.cart.items = cartData.order?.items;
          $template.cart.samples = cartData.order?.samples;
        }
        self.initThreshold($template);
        self.checkSelectedProducts($template);
        self.checkThreshold($template);
      });
    },

    init: function ($template) {
      var self = this;

      self.getCartData($template);
      self.getProductsInventoryStatus($template);
    },

    getCartData: function ($template) {
      var self = this;

      generic.jsonrpc.fetch({
        method: 'trans.get',
        params: [
          {
            trans_fields: ['TRANS_ID', 'totals'],
            payment_fields: [],
            order_fields: ['items', 'samples', 'offerCodes']
          }
        ],
        onSuccess: function (response) {
          var cartData = response.getValue();

          if (cartData) {
            $template.cart.subtotal = cartData.subtotal && parseFloat(cartData.subtotal);
            $template.cart.items = cartData.order?.items;
            $template.cart.samples = cartData.order?.samples;
          }
          self.initThreshold($template);
          self.checkSelectedProducts($template);
          self.checkThreshold($template);
        },
        onFailure: function (response) {
          var errorObjectsArray = response.getMessages();

          if (errorObjectsArray.length !== 0) {
            console.error(errorObjectsArray);
          }
        }
      });
    },

    initThreshold: function ($template) {
      var self = this;
      var $availableThreshold = $template.nodes.$thresholdContainer.first();

      $template.nodes.$thresholdContainer.each(function () {
        var $threshold = $(this);
        var thresholdAmount = parseFloat($threshold.attr('data-threshold-amount')) || 0;

        if (thresholdAmount <= $template.cart.subtotal) {
          $availableThreshold = $threshold;
        }
      });

      $template.nodes.$thresholdContainer.not($availableThreshold).addClass('hidden');
      $availableThreshold.removeClass('hidden');

      if ($availableThreshold.attr('data-threshold-offer-code')) {
        $template.nodes.$productButton.removeClass('disabled');
        $template.threshold.value = parseInt($availableThreshold.attr('data-threshold-value'));
        $template.threshold.amount = parseFloat($availableThreshold.attr('data-threshold-amount'));
        $template.threshold.offerCode = $availableThreshold.attr('data-threshold-offer-code');
        $template.threshold.$atbPopup = $availableThreshold.find(self.selectors.thresholdAtbPopupContainer);

        if ($template.threshold.value === 1) {
          $template.nodes.$productButton.text($template.buttonAddToBagText);
        }
      }

      if ($template.threshold.value > 1) {
        self.initStickyItems($template);
        $template.nodes.$stickyContainer.addClass('active');
      } else {
        $template.nodes.$stickyContainer.removeClass('active');
      }
    },

    checkThreshold: function ($template) {
      var self = this;

      if ($template.selectedSkus.length < $template.threshold.value) {
        $template.nodes.$productButton.removeClass('disabled');
      } else {
        $template.nodes.$productButton.not('.selected').addClass('disabled');
      }
      self.updateStickyContainer($template);
    },

    checkSelectedProducts: function ($template) {
      var self = this;
      var cartItems = [...$template.cart?.items, ...$template.cart?.samples];

      $template.selectedSkus = [];
      $template.nodes.$productButton.removeClass('button--dark selected').addClass('button--light').text($template.threshold.value > 1 ? $template.buttonSelectText : $template.buttonAddToBagText);
      if (cartItems.length !== 0) {
        cartItems.forEach(function (item) {
          var baseSkuId = item['sku.SKU_BASE_ID'];
          var $product = $template.nodes.$product.filter(`[data-sku-base-id="${baseSkuId}"]`);

          $product.length > 0 && self.toggleProduct($template, $product, true);
        });
      }
    },

    toggleProduct: function ($template, $product, forceSelect = false) {
      var self = this;
      var $button = $product.find(self.selectors.productButton);
      var skuBaseId = $product.attr('data-sku-base-id');

      if (!$template.selectedSkus.includes(skuBaseId) || forceSelect) {
        $template.selectedSkus.push(skuBaseId);
        $button.removeClass('button--light').addClass('button--dark selected').text($template.buttonSelectedText);
      } else {
        $template.selectedSkus = $template.selectedSkus.filter((skuId) => skuId !== skuBaseId);
        $button.removeClass('button--dark selected').addClass('button--light').text($template.threshold.value > 1 ? $template.buttonSelectText : $template.buttonAddToBagText);
      }
    },

    applyOffer: function ($template) {
      var self = this;

      if (!$template.threshold.offerCode || $template.selectedSkus.length === 0 || $template.loading) {
        return;
      }

      self.loading = true;
      generic.jsonrpc.fetch({
        method: 'offer.removeOffersByCode',
        params: [
          {
            offer_codes: [$template.threshold.offerCode]
          }
        ],
        onBoth: function () {
          generic.jsonrpc.fetch({
            method: 'offers.apply',
            params: [
              {
                offer_code: $template.threshold.offerCode,
                do_not_defer_messages: 1,
                benefits: {
                  ChoiceOfSkus: {
                    choices: $template.selectedSkus
                  }
                }
              }
            ],
            onBoth: function () {
              var itemsLeftCount = $template.threshold.value - $template.selectedSkus.length;
              var thresholdPopupPartialText =
                itemsLeftCount === 0 ? '' :
                  itemsLeftCount === 1 ? $template.thresholdPopupPartialSingularText :
                    $template.thresholdPopupPartialPluralText;

              if (thresholdPopupPartialText?.length) {
                $template.nodes.$thresholdPopupPartialText.text(thresholdPopupPartialText.replaceAll('{items_left_count}', itemsLeftCount)).removeClass('hidden');
              } else {
                $template.nodes.$thresholdPopupPartialText.addClass('hidden');
              }

              generic.overlay.launch({
                content: $template.threshold.$atbPopup.clone().removeClass('hidden'),
                cssClass: 'guided-pick-popup-overlay dynamic-pick-popup-overlay',
                hideOnClickOutside: true,
                backgroundNodeClickHide: true
              });
              $template.loading = false;
            }
          });
        }
      });
    },

    removeOffer: function ($template) {
      if ($template.loading) {
        return;
      }

      $template.loading = true;
      generic.jsonrpc.fetch({
        method: 'offer.removeOffersByCode',
        params: [
          {
            offer_codes: [$template.threshold.offerCode]
          }
        ],
        onBoth: function () {
          $template.loading = false;
        }
      });
    },

    showCartOverlay: function () {
      generic.jsonrpc.fetch({
        method: 'trans.get',
        params: [
          {
            trans_fields: ['TRANS_ID', 'totals'],
            payment_fields: [],
            order_fields: ['items', 'samples', 'offerCodes']
          }
        ],
        onSuccess: function (response) {
          var cartData = response.getValue();
          var args = {
            trans_data: cartData
          };

          if (typeof cartData === 'undefined' || !cartData) {
            return;
          }
          $(document).trigger('addToCart.success', [args]);
        },
        onFailure: function (response) {
          var errorObjectsArray = response.getMessages();

          if (errorObjectsArray.length !== 0) {
            console.error(errorObjectsArray);
          }
        }
      });
    },

    updateStickyContainer: function ($template) {
      var self = this;

      self.updateStickyText($template);
      self.updateStickyItems($template);
      self.updateStickyAtbButton($template);
    },

    updateStickyText: function ($template) {
      var itemsLeftCount = $template.threshold.value - $template.selectedSkus.length;
      var stickyText =
        itemsLeftCount === 0 ? $template.stickyCompleteText :
          itemsLeftCount === 1 ? $template.stickyPartialSingularText :
            $template.stickyPartialPluralText;

      if (stickyText?.length) {
        $template.nodes.$stickyText.text(stickyText.replaceAll('{items_left_count}', itemsLeftCount)).removeClass('hidden');
      } else {
        $template.nodes.$stickyText.addClass('hidden');
      }
    },

    initStickyItems: function ($template) {
      var self = this;

      $template.nodes.$stickyItemContainer.find(self.selectors.stickyItem).not('.hidden').remove();
      $template.nodes.$stickyItemContainer.append(
        Array.from({ length: $template.threshold.value }, () => $template.nodes.$stickyItem.clone().removeClass('hidden'))
      );
    },

    updateStickyItems: function ($template) {
      var self = this;

      self.initStickyItems($template);
      $template.selectedSkus.forEach(function (skuId) {
        var $stickyItem = $template.nodes.$stickyItemContainer.find(`${self.selectors.stickyItem}[data-sku-base-id="${skuId}"]`);
        var $product = $template.nodes.$product.filter(`[data-sku-base-id="${skuId}"]`);

        if ($stickyItem.length < 1 && $product.length > 0) {
          var $emptyStickyItem = $template.nodes.$stickyItemContainer.find(self.selectors.stickyItem).not('.hidden').not('[data-sku-base-id]').first();

          if ($emptyStickyItem.length) {
            var productImageSrc = $product.find(self.selectors.productImage).attr('src');
            var productImageAlt = $product.find(self.selectors.productImage).attr('alt');
            var $emptyStickyItemButton = $emptyStickyItem.find(self.selectors.stickyItemButton);
            var $stickyItemImageContainer = $emptyStickyItem.find(self.selectors.stickyItemImageContainer);

            $emptyStickyItem.attr('data-sku-base-id', skuId).removeClass('empty');
            $stickyItemImageContainer.empty().append($('<img>', {
              'class': 'guided-pick--sticky-item-image',
              src: productImageSrc,
              alt: productImageAlt
            }));

            $emptyStickyItemButton.once().on('click', function () {
              self.toggleProduct($template, $product);
              self.checkThreshold($template);
            });
          }
        }
      });
    },

    updateStickyAtbButton: function ($template) {
      if ($template.selectedSkus.length < 1) {
        $template.nodes.$stickyButton.addClass('disabled');
      } else {
        $template.nodes.$stickyButton.removeClass('disabled');
      }
    },

    getProductsInventoryStatus: function ($template) {
      var self = this;
      var params = {
        categories: [$template.attr('data-category-id')],
        category_fields: ['products'],
        product_fields: ['PRODUCT_ID', 'PROD_RGN_NAME', 'SHORT_DESC', 'PRODUCT_SIZE', 'skus'],
        sku_fields: ['isOrderable', 'SKU_ID', 'SKU_BASE_ID', 'INVENTORY_STATUS', 'LARGE_IMAGE', 'IMAGE_M_V3']
      };

      if (!$template.attr('data-category-id')) {
        return;
      }

      generic.jsonrpc.fetch({
        method: 'prodcat',
        params: [params],
        onSuccess: function (response) {
          var resultData = response.getValue();
          var productData = resultData.categories[0].products;

          productData.forEach(function (product) {
            if (product.skus.length > 0) {
              var sku = product.skus[0];
              var $product = $template.nodes.$product.filter(`[data-sku-base-id="${sku.SKU_BASE_ID}"]`);

              if ($product.length > 0) {
                var $productButton = $product.find(self.selectors.productButton);

                $product.attr('data-inventory-status', sku.INVENTORY_STATUS);
                if (sku.isOrderable) {
                  $productButton.removeClass('disabled').addClass('js-guided-pick-product-button').text($template.threshold.value > 1 ? $template.buttonSelectText : $template.buttonAddToBagText);
                } else {
                  $productButton.addClass('disabled').removeClass('js-guided-pick-product-button').text($template.buttonSoldOutText);
                }
                $template.nodes.$productButton = $(self.selectors.productButton, $template);
              }
            }
          });
        },
        onFailure: function () {}
      });
    },
  };
})(jQuery);
